import React from 'react';
import { Link } from 'react-router-dom';

import ReactFileReader from 'react-file-reader';
import { guid, COLUMN_DATATYPE_NAMES, matchColumnType, getSelectedTemplates } from '../common/Utilities';

import SurveyDataService from '../services/SurveyDataService'
import { Label } from 'office-ui-fabric-react';
import { ComboBox } from 'office-ui-fabric-react/lib/ComboBox';
import { ProgressIndicator } from 'office-ui-fabric-react/lib/ProgressIndicator';
import ColumnMatcher from './ColumnMatcher';
import MatchedColumnRow from './MatchedColumnRow';
import { getGeoLocationObject } from '../common/GeoLocation';

import '../App.css';

class UploadTestPoints extends React.Component {

  uploadedRecords = 0;

  constructor(props) {
    super(props);

    this.state = { ...props.data };

    if (! this.state.upload) {
        const upload = {
            sample: [],
            columnNames: [],
            haveSaved: false,
            processedRecords: 0,
            errors: []
        }
        this.uploadedRecords = this.state.percentUploadComplete=0;
        this.state.upload = upload;
        if (this.state.selectedTemplateKey.length === 0) {
            if (this.state.survey.Templates && this.state.survey.Templates.L.length > 0) {
                this.state.selectedTemplates = getSelectedTemplates(this.state.survey);              
                this.state.selectedTemplateKey = this.state.selectedTemplates[0];
            } else {
                
            }
        }
    }
}

async componentDidMount() {
    // Get a local copy of the survey templates to use for loading / mapping csv
    let templateColumns = {};
    let csvColumnMatch = {};
    this.state.selectedTemplates.forEach((t) => {
        templateColumns[t] = this.state.survey.getColumns(t).filter(col => 
            col.DataType.S !== "Separator" && col.DataType.S !== "Photo" &&
            col.ColumnName.S !== "projName" && col.ColumnName.S !== "projDesc" &&
            col.ColumnName.S !== "jobNumVendor" && col.ColumnName.S !== "surveyName" &&
            col.ColumnName.S !== "surveyActivity" && col.ColumnName.S !== "itemClass" && col.ColumnName.S !== "clientName"
        );
        csvColumnMatch[t] = [];
        // templateColumns.forEach((t) => {
        //     csvColumns.push(-1);
        // });
    });
    this.setUploadState("templateColumns", templateColumns);
    this.setUploadState("csvColumnMatch", csvColumnMatch);
}

columnMatching = () => {
    const columnNames = this.state.upload.csvColumnNames;
    const templateColumns = this.state.upload.templateColumns[this.state.selectedTemplateKey];
    let csvColumnMatch = this.state.upload.csvColumnMatch;
    // Loop through the template and try to match csv columns
    for(let i=0; i<templateColumns.length; i++) {
        const tcol = templateColumns[i].ColumnName.S.toLowerCase();
        delete csvColumnMatch[this.state.selectedTemplateKey][i];
        const columnType = matchColumnType(templateColumns[i].DataType.S);
        for (let j=0; j<columnNames.length; j++) {
            const csvName =columnNames[j].toLowerCase();
            if (columnType === COLUMN_DATATYPE_NAMES.single) {
                if (tcol === csvName) {
                    csvColumnMatch[this.state.selectedTemplateKey][i] = j;
                }
            } else if (columnType === COLUMN_DATATYPE_NAMES.onoff) {
                if (csvName.endsWith("off") || csvName.endsWith("on")) {
                    const offon = csvName.endsWith("on") ? "on" : "off";
                    const partialCsvName = csvName.substring(0,csvName.length-(offon === "on" ? 2 : 3));
                    if (tcol === partialCsvName) {
                        if (typeof(csvColumnMatch[this.state.selectedTemplateKey][i]) === "undefined") {
                            csvColumnMatch[this.state.selectedTemplateKey][i] = {};
                        }
                        csvColumnMatch[this.state.selectedTemplateKey][i][offon] = j;
                    }
                }
            } else if (columnType === COLUMN_DATATYPE_NAMES.geo) {
                if (csvName === "latitude" || csvName === "longitude" ) {
                    if (typeof(csvColumnMatch[this.state.selectedTemplateKey][i]) === "undefined") {
                        csvColumnMatch[this.state.selectedTemplateKey][i] = {};
                    }
                    csvColumnMatch[this.state.selectedTemplateKey][i][csvName] = j;
                }
            }
        }
    }
    this.setUploadState("csvColumnMatch", csvColumnMatch);
}
setUploadState = (property, value, callback) => {
    const upload = this.state.upload;
    upload[property] = value;
    this.setState({upload: upload}, callback);
}
// RFC 4180 compliant CSV parser. Correctly handles quoted fields that
// contain commas, double quotes ("" -> "), and embedded carriage
// returns / newlines. Returns an array of rows, each row an array of
// unquoted cell values.
parseCSV = (text) => {
    const rows = [];
    let row = [];
    let field = "";
    let inQuotes = false;
    let fieldWasQuoted = false;
    const len = text.length;

    const pushField = () => {
        row.push(field);
        field = "";
        fieldWasQuoted = false;
    };
    const pushRow = () => {
        pushField();
        rows.push(row);
        row = [];
    };

    for (let i = 0; i < len; i++) {
        const char = text[i];
        if (inQuotes) {
            if (char === '"') {
                if (text[i + 1] === '"') {
                    // escaped double quote inside a quoted field
                    field += '"';
                    i++;
                } else {
                    inQuotes = false;
                }
            } else {
                field += char;
            }
        } else {
            if (char === '"') {
                inQuotes = true;
                fieldWasQuoted = true;
            } else if (char === ',') {
                pushField();
            } else if (char === '\r') {
                // consume the following \n of a \r\n sequence
                if (text[i + 1] === '\n') {
                    i++;
                }
                pushRow();
            } else if (char === '\n') {
                pushRow();
            } else {
                field += char;
            }
        }
    }
    // flush the final field / row (file may not end with a newline)
    if (field !== "" || fieldWasQuoted || row.length > 0) {
        pushRow();
    }
    return rows;
}
handleFiles = files => {
    let reader = new FileReader();
    reader.onload = (e) => {
        // Strip a UTF-8 byte order mark so the first column header (and the
        // "id" detection / column matching below) isn't prefixed with \uFEFF.
        let text = reader.result;
        if (text.charCodeAt(0) === 0xFEFF) {
            text = text.slice(1);
        }
        // Parse honoring quoted fields (embedded commas, quotes and newlines)
        const rows = this.parseCSV(text);
        // drop completely blank rows (e.g. a trailing newline)
        const lines = rows.filter(r => !(r.length === 1 && r[0] === ""));
        if (lines.length === 0) {
            this.setUploadState("csvColumnNames", [], this.columnMatching);
            this.setUploadState("sample", []);
            return;
        }
        // Get the column names from the first line
        const columnNames = lines[0];
        this.setUploadState("csvColumnNames",columnNames,this.columnMatching);
        lines.splice(0,1);  // remove the column headers
        // object to hold the entire sample file
        let sample = [];

        lines.forEach(function(columns) {
            // Skip rows that are entirely empty (e.g. a spare ",,," line) so
            // they don't show up as blank rows in the preview or get imported.
            if (columns.every(function(c) { return typeof(c) === "undefined" || c.trim() === ""; })) {
                return;
            }
            // Normalize the row to the header column count. Real-world CSVs
            // frequently omit trailing empty cells (or contain a stray extra
            // delimiter); pad/truncate so the row still lines up with the
            // columns instead of being dropped as a blank preview row.
            let sampleItem = [];
            for (let i=0; i<columnNames.length; i++) {
                sampleItem.push(typeof(columns[i]) === "undefined" ? "" : columns[i]);
            }
            sample.push(sampleItem);
        });
        // If the csv has an "id" column, pre-generate an id for any row that is
        // missing one so the row shows a new id in the preview grid and gets
        // imported (matching the behaviour of a csv with no id column).
        const idIndex = columnNames.findIndex(name => name.trim().toLowerCase() === "id");
        if (idIndex > -1) {
            sample.forEach(function(row) {
                if (row.length === columnNames.length && (typeof(row[idIndex]) === "undefined" || row[idIndex] === "")) {
                    row[idIndex] = guid();
                }
            });
        }
        this.setUploadState("sample", sample);
    }
    reader.readAsText(files[0]);
}
columnExists = (columns, columnName) => columns.filter(col => col.ColumnName.S === columnName).length > 0;

buildPoint = () => {

};

templateLabel = (value) => {
    const item = this.state.survey.Templates.L.find(item => item.M.Value.S === value);
    return item ? item.M.Label.S : `Error - Template ${value} not found`;
};

templateLabels = () => {
    return this.state.selectedTemplates.map(item => {
        return { key:item, text: this.templateLabel(item) };
    });
};

// templateColumns = () => {
//     return 
// }
onTemplateChange = (e, option) => {
    const upload = this.state.upload;
    upload["sample"] = [];
    upload["haveSaved"] = false;
    upload["processedRecords"] = 0;
    upload["errors"] = [];
    this.uploadedRecords = 0;
    this.setState({
        selectedTemplateKey: (option !== undefined) ? option.key : "",
        selectedRecord: null,
        percentUploadComplete: 0,
        upload: upload
    });
};

saveChanges = () => {
    this.setUploadState("haveSaved", true);
    const survey = this.state.survey;
    const selectedTemplateKey = this.state.selectedTemplateKey;
    const surveyColumns = survey.getColumns(selectedTemplateKey);
    const templateColumns = this.state.upload.templateColumns[selectedTemplateKey];
    const columnExists = this.columnExists;
    const csvColumnMatch = this.state.upload.csvColumnMatch[selectedTemplateKey];
    const nvalue = value => isNaN(parseFloat(value)) ? null : parseFloat(value).toString();
    const db = new SurveyDataService();
    this.state.upload.sample.forEach((csvRow) => {
        // get a copy of the template
        var asset = {};
        let uuid = guid();

        asset.M = {};
        // Handle the common elements that get populated from the survey
        if (columnExists(surveyColumns,"projName") && survey.projName !== "")
            asset.M.projName = { S: survey.projName };
        if (columnExists(surveyColumns, "clientName") && survey.client !== "")
            asset.M.clientName = { S: survey.client };
        if (columnExists(surveyColumns,"projDesc") && survey.projDesc !== "")
            asset.M.projDesc = { S: survey.projDesc };
        if (columnExists(surveyColumns,"jobNumVendor") && survey.jobNumVendor !== "")
            asset.M.jobNumVendor = { S: survey.jobNumVendor };
        if (columnExists(surveyColumns,"surveyName") && survey.surveyName !== "")
            asset.M.surveyName = {S: survey.surveyName};
        if (columnExists(surveyColumns,"surveyActivity") && survey.surveyActivity !== "")
            asset.M.surveyActivity = {S: survey.surveyActivity};
        if (columnExists(surveyColumns,"itemClass")) asset.M.itemClass = { S: selectedTemplateKey };

        // populate the remainder of the columns
        templateColumns.forEach((item, index) => {

            if (matchColumnType(item.DataType.S) === COLUMN_DATATYPE_NAMES.single) {
                if (typeof(csvColumnMatch[index]) !== "undefined") {
                    if (csvRow[csvColumnMatch[index]] !== "") {
                        const cname = item.DataType.S.toLowerCase(); 
                        if (cname === "meteracv" || cname === "decimal" || cname === "integer" || cname === "meteraca" || cname === "meteracohmns" || cname === "meteracma" || cname === "meteracmv" || cname === "meterdcv" || cname === "meterdca" || cname === "meterdcohmns" || cname === "meterdcma" || cname === "meterdcmv") {
                            if (nvalue(csvRow[csvColumnMatch[index]]) !== null) {
                                asset.M[item.ColumnName.S] = { N: nvalue(csvRow[csvColumnMatch[index]]) };
                            }
                        } else {
                            asset.M[item.ColumnName.S] = { S: csvRow[csvColumnMatch[index]] };
                        }
                    }
                    // If the guid exists, use it so it gets associate with the point.
                    // If the id cell is blank, keep the generated uuid so the row is
                    // still populated and imported (same behaviour as a csv without an id column).
                    if (item.DataType.S.toLowerCase() === "guid") {
                        const idValue = csvRow[csvColumnMatch[index]];
                        if (typeof(idValue) !== "undefined" && idValue !== "") {
                            uuid = idValue;
                        }
                        asset.M[item.ColumnName.S] = { S: uuid };
                    }
                } else {
                    // for guid's if it wasn't matched use a new one
                    if (item.DataType.S.toLowerCase() === "guid") {
                        asset.M[item.ColumnName.S] = { S: uuid };
                    }
                }
            } else if (matchColumnType(item.DataType.S) === COLUMN_DATATYPE_NAMES.onoff) {
                if (typeof(csvColumnMatch[index]) !== "undefined") {
                    if (nvalue(csvRow[csvColumnMatch[index]["off"]]) !== null && nvalue(csvRow[csvColumnMatch[index]["on"]]) !== null) {
                        asset.M[item.ColumnName.S] = {M: {
                            off: { N: nvalue(csvRow[csvColumnMatch[index]["off"]]) },
                            on: { N: nvalue(csvRow[csvColumnMatch[index]["on"]]) }
                        }}
                    }
                }
            } else if (matchColumnType(item.DataType.S) === COLUMN_DATATYPE_NAMES.geo) {
                if (typeof(csvColumnMatch[index]) !== "undefined") {
                    if (nvalue(csvRow[csvColumnMatch[index]["latitude"]]) !== null && nvalue(csvRow[csvColumnMatch[index]["longitude"]]) !== null) {
                        asset.M[item.ColumnName.S] = getGeoLocationObject();
                        asset.M[item.ColumnName.S].M.geo_lat = { N: nvalue(csvRow[csvColumnMatch[index]["latitude"]]) };
                        asset.M[item.ColumnName.S].M.geo_lon = { N: nvalue(csvRow[csvColumnMatch[index]["longitude"]]) };
                    }
                }
            }    
        });
        
        //asset.M.id = { S: uuid };
        let samplePoint = {
            asset: asset,
            id: { S: uuid },
            jobNumVendor: { S: survey.jobNumVendor},
            lastEditDate: { S: (new Date()).toISOString() },
            //username: { S: ""}
        }
        //console.log(JSON.stringify(samplePoint));
        db.put(samplePoint).then((x) => {
            this.incrementComplete();
        }).catch((err) => {
            let errors = this.state.upload.errors;
            errors.push({ statusCode: err.statusCode, code: err.code, message: err.message});
            this.setUploadState("errors", errors);
            this.incrementComplete();
            //console.error.bind(console)
        });
    });
};

incrementComplete = () => {
    const upload = this.state.upload;
    this.uploadedRecords += 1; // attempting to use a class variable to push into state to try to resolve state update timing
    upload.processedRecords = this.uploadedRecords;
    // Trying to keep the set states to a minimum to improve timing for the progress indicator, it's not working
    this.setState({upload: upload, percentUploadComplete: this.uploadedRecords/upload.sample.length});
}
onMatchingChange = csvColumnMatch => {
    this.setUploadState("csvColumnMatch", csvColumnMatch);
}
render() {
    const upload = this.state.upload;
    const selectedTemplates = this.state.selectedTemplates;
    const selectedTemplateKey = this.state.selectedTemplateKey;
    const thisInstance = this;
    return (
    <div className="container-fluid">
        <h2 className ="heading" >Upload Test Points</h2>
            <p className="ms-Label">
            Select the .csv file to upload
        </p>
        <ReactFileReader fileTypes={[".csv"]} handleFiles={this.handleFiles}>
                <button style={{ 'fontSize': '12px', 'color': '#676767' }} className='btn'>Open CSV</button>
        </ReactFileReader>
        <div style={{ marginTop: "25px" }}>
        {
            (selectedTemplates.length === 1) ?
                <Label>{this.templateLabel(selectedTemplates[0])}</Label> :
                <ComboBox
                    selectedKey={selectedTemplateKey}
                    allowFreeform={false}
                    autoComplete="off"
                    onChange={this.onTemplateChange}
                    options={this.templateLabels()}
                />
        }
        </div>
        { // Show the no data message if nothing has been loaded
            upload.sample.length === 0 &&
                <p style={{ marginLeft: "10px", color: "#ccc", 'fontSize': '12px'}}>No Data</p>
        }
        {
            upload.haveSaved &&
            <div className="row">
                <div>
                    <p style={{marginLeft:"10px"}}>Processed {upload.processedRecords} of {upload.sample.length}
                    { upload.errors.length > 0 && <span> with <span style={{color:"red"}}>{upload.errors.length} Errors</span></span> }
                    { upload.processedRecords === upload.sample.length && <span style={{fontWeight:"bold"}}> Upload Processing has Completed.</span>}
                    </p>
                    <div className="lds-spinner" style={{position:"absolute", top:"150px", left:"260px", display: (this.state.percentUploadComplete !== 1) ? "block" : "none"}}><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
                    <ProgressIndicator label="" description="Uploading points" percentComplete={this.state.percentUploadComplete} />
                </div>
                {
                upload.errors.length > 0 &&
                <div style={{maxHeight:"200px", overflowY:"auto"}}>
                    <div>Errors</div>
                    { upload.errors.map((err, index) => {
                        return <div key={index}>{err.statusCode} {err.code} {err.message}</div>
                        })
                    }
                </div>
                }
            </div>            
        }
        {
            selectedTemplateKey !== "" && upload.templateColumns && upload.sample.length > 0 &&
            <div style={{height:"600px", overflow:"auto", marginTop:"5px", marginBottom:"10px"}}>
                <table className="previewTable"><tbody>
                    <tr>
                        {upload.templateColumns[selectedTemplateKey].map(function(item, index){
                            return <ColumnMatcher item={item} index={index} upload={upload} selectedKey={selectedTemplateKey} key={index} 
                            onMatchingChange={thisInstance.onMatchingChange} />
                        })}
                    </tr>
                    {
                        upload.sample.map(function(item, index) {
                            return <tr key={ index }>
                                <MatchedColumnRow csvRow={item} upload={upload} selectedKey={selectedTemplateKey} key={index} />
                            </tr>
                        })
                    }
                    </tbody>
                </table>
            </div>
        }

        {/* { // Show the preview table
            upload.sample.length>0 &&
        <div style={{height:"500px", overflow:"auto", marginTop:"5px", marginBottom:"10px"}}>
        
        <p>Review the data to verify that this is what you would like to save. Once satisfied press the Save button.</p>
        <table className="previewTable"><tbody>
            <tr>
            {upload.csvColumnNames.map(function(item, index){
                 return <th key={ index }>{item}</th>
                 })
            }
            </tr>
                {upload.sample.map(function(item, index){
                    return <tr key={ index }>
                        { item.map((col, ci) => {
                            return <td key={ci}>{col}</td>
                        })}
                    </tr>
                  })}
            </tbody>
        </table>
        </div>
        } */}
          <div className="buttonRow">
          <div>
                    <button style={{ 'fontSize': '12px'}} onClick={this.saveChanges} disabled={upload.sample.length!==0 && !upload.haveSaved ? "" : "disabled"} className="btn btn-primary">Upload</button>
              {/* <button onClick={this.handleOnNextButtonClicked} className="btn btn-default">Next &raquo;</button> */}
          </div>
          <div>
            <Link to="/">
                        <button style={{ 'fontSize': '12px' }} className="btn btn-default">Home</button>
            </Link>
           </div>
        </div>
      </div>
    );
  }
}

export default UploadTestPoints;
